export const settingsConfigHelp = {
  neatolabsMachine:
    'Turn this on when the selected store uses the Neatolabs production workflow. It enables machine-specific tools and options for that store.',
  profileVersionV2:
    'Turn this on to use version 2 product profiles and the current profile editor. Leave it off only when this store still depends on legacy V1 profiles.',
  customizationElementSize:
    'Set the default width of each customer-added element as a percentage of its product section. You can also require a minimum pixel size for uploaded images.',
  profanityRules:
    'Choose how profanity scores are classified as Accepted, Requires Manual Check, or Rejected. You can also enable text checks and test a phrase before saving.',
  companyLogo:
    'Upload the logo used for the selected store. Use a clear image with a transparent background when possible; uploading or removing it saves automatically.',
  brandColor:
    'Choose the primary brand color used by the selected store, or enter an exact six-digit hex value such as #79BC61. Changes save automatically.',
  elementSize: {
    text: 'Set the default width of a newly added text element as a percentage of the product section width.',
    graphic: 'Set the default width of a newly added library graphic as a percentage of the product section width.',
    aiImage: 'Set the default width of a newly generated AI image as a percentage of the product section width.',
    monogram: 'Set the default width of a newly added monogram as a percentage of the product section width.',
    uploadGraphic: 'Set the default width of a customer-uploaded graphic as a percentage of the product section width.',
  },
  minimumResolution: {
    width: 'Set the minimum accepted width, in pixels, for a customer-uploaded image.',
    height: 'Set the minimum accepted height, in pixels, for a customer-uploaded image.',
  },
  profanityStatus: {
    accepted: 'Enable this outcome to automatically accept images whose profanity score falls inside its range. The percentage sets the upper end of the range.',
    manualCheck: 'Enable this outcome to send images in this score range to manual review instead of accepting or rejecting them automatically.',
    rejected: 'Enable this outcome to automatically reject images whose profanity score falls inside its range. The final active range always ends at 100%.',
  },
  textProfanity:
    'Turn this on to check customer-entered text against the profanity policy. Turn it off only when this store should accept text without an automated check.',
  testProfanityText:
    'Enter a sample phrase and choose Test to preview the result returned by the current profanity policy for the selected store.',
} as const
